import PropTypes from 'prop-types';
import React from 'react';
import Field from './index';

export default function renderField({
  input,
  meta: { touched, error, warning, asyncValidating },
  ...args
}) {
  const validationMessage = touched
    ? error || warning || args.validationMessage
    : args.validationMessage;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;

  return (
    <Field
      isValid={isValid}
      id={id}
      {...args}
      {...input}
      asyncValidating={asyncValidating}
      validationMessage={validationMessage}
    />
  );
}

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
};
